.selected-store-details a{color:var(--home-page-selected-store-phone-color)}.address{opacity:.5}
/*# sourceMappingURL=home-page-store-dropdown.component-WUPTVUXU.css.map */
